import { render } from "./Branding.vue?vue&type=template&id=77b5d52e"
import script from "./Branding.vue?vue&type=script&lang=js"
export * from "./Branding.vue?vue&type=script&lang=js"

import "./Branding.vue?vue&type=style&index=0&id=77b5d52e&lang=scss"

import exportComponent from "/Users/documedias/gitlab/virtuell/ispad2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__